import React from 'react'

import List from 'components/SalesEvents/List'

const SalesEvents = () => {
  return (
    <div className="items sales-events">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Event Name</li>
          <li className="header__menu-item">Event Type</li>
          <li className="header__menu-item">Start Date & Time</li>
          <li className="header__menu-item">Pre-Order Active</li>
        </ul>
      </div>
      <List />
    </div>
  )
}

export default SalesEvents
